import { lazy } from 'react';
import { authRoles } from '@/app/auth';
import { apiRoutes } from '@/app/apiConfig/apiRoutes';

const AddGoalPage = lazy(() => import('./AddGoalPage'));

const AddGoalConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.UserManagement,
  routes: [
    {
      path: apiRoutes.addGoal,
      element: <AddGoalPage />,
    },
  ],
};

export default AddGoalConfig;
